
import { nanoid } from 'nanoid/index.browser.js';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';

export default {
  name: "QdapHomeQuestionnaire",
  mixins: [eventTrackingMixins],
  props: {
    anchor: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      pageStatus: 0,
      stateId: '',
      locale: this.$normalizeLocale(this.$i18n.locale),
      collapseActive: false,
      selectedItems: {},
    }
  },
  computed: {
    showLanding() {
      return this.pageStatus === 0;
    },
    showQuestions() {
      return this.pageStatus !== 'products';
    },
    showProducts() {
      return this.pageStatus === 'products';
    },
    getSelected() {
      return this.selectedItems[this.pageStatus];
    }
  },
  watch: {
    pageStatus(newVal, oldVal) {
      if ( newVal !== oldVal ) {
        this.checkFocusSection();
      }
    }
  },
  mounted() {
    this.stateId = nanoid();
    this.checkFocusUrlHash();
  },
  methods: {
    checkFocusSection() {
      const targetId = this.anchor;
      this.scrollToSection(targetId);
    },
    checkFocusUrlHash() {
      if (this.$route.hash) {
        const targetId = this.$route.hash.substring(1);
        this.scrollToSection(targetId);
      }
    },
    scrollToSection(targetId) {
      const section = document.getElementById(targetId);
      if ( section ) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
    },
    goPage(target) {
      if ( target === 0 ) {
        this.selectedItems = {};
        this.stateId = nanoid();
      }
      this.pageStatus = target;
    },
    updateSelected(item) {
      // console.debug('item', item);
      this.selectedItems[item.id] = item.value;
    },
    handleTracking(event, label, value, stateId) {
      const eventTrackingParams = this.initEventTrackingParams();

      eventTrackingParams.a = event;
      eventTrackingParams.l = label;
      eventTrackingParams.c = value;
      eventTrackingParams.xr_id = stateId;

      this.sendEventTracking(eventTrackingParams);
    },
    handleStart() {
      this.goPage(1);
      this.handleTracking('to_qdap_questionnaire', location.href, 'qdap_questionnaire_start', this.stateId);
    }
  }
}
